<template>
  <vx-card v-show="isCardActiveLocal" :title="questionCardTitle">
    <div class="vx-row pb-3">
      <div class="vx-col w-full mb-2">
        <label>Title</label>
        <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required|max:128'" name="Title" v-model="questionData.title" />
        <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
      </div>
    </div>
    <div class="vx-row pb-3">
      <div class="vx-col w-full mb-2">
        <label>Question Text</label>
        <quill-editor v-model="questionData.questionText" /> <!--  :options="editorOption" -->
      </div>
    </div>

    <div class="vx-row pb-3">
      <div class="vx-col w-1/2 mb-2">
        <label>Classification</label>
        <v-select class="style-chooser" placeholder="Select / Add Question Classification" taggable push-tags :options="questionClassifications" @option:created="addNewClassification" v-model="classificationDropdown"></v-select>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-1/2">
        <div class="vx-col sm:w-1/3 w-1/3 mb-2 mt-2">
          <label>Score</label>
          <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'numeric'" name="Score" v-model="questionData.score" />
          <span class="text-danger text-sm" v-show="errors.has('Score')">{{ errors.first('Score') }}</span>
        </div>
      </div>
    </div>

    <div v-show="isCombinationTableActive">
      <vs-divider>Background Image</vs-divider>

      <vs-button class="mb-2 new-signature-button-on-select upload-background-image" color="success" type="filled" icon-pack="feather" icon="icon-upload" @click.prevent="showFileChooserBackgroundCropper">Upload Background Image</vs-button>

      <div class="vx-col cropper-div" ref="backgroundCropperdiv">
        <!-- <div v-if="!showCropImage"> -->
        <div v-show="newImageBackgroundClicked">
          <input
            ref="inputBackgroundCropper"
            type="file"
            name="image"
            accept="image/*"
            @input="setImageBackgroundCropper"
          />

          <section class="cropper-area_tool">
            <div class="img-cropper">
              <vue-cropper
                v-show="sceneImageUrlTemp"
                ref="backgroundCropper"
                :src="sceneImageUrlTemp"
                preview=".preview"
                :aspectRatio="1/1"
                :initialAspectRatio="1/1"
              />
            </div>
          </section>

          <div class="vx-vol cropper-area_buttons">
            <div class="vx-row ml-0">
              <vs-button v-show="newImageBackgroundClicked" class="mr-5 mt-3" type="border" color="warning" icon-pack="feather" icon="icon-refresh-ccw" @click.prevent="resetBackgroundCropper">Reset</vs-button>

              <vs-button v-show="newImageBackgroundClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-zoom-in" @click.prevent="zoomBackgroundCropper(0.2)" />
              <vs-button v-show="newImageBackgroundClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-zoom-out" @click.prevent="zoomBackgroundCropper(-0.2)" />

              <vs-button v-show="newImageBackgroundClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-left" @click.prevent="moveBackgroundCropper(-10, 0)" />
              <vs-button v-show="newImageBackgroundClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-right" @click.prevent="moveBackgroundCropper(10, 0)" />
              <vs-button v-show="newImageBackgroundClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-up" @click.prevent="moveBackgroundCropper(0, -10)" />
              <vs-button v-show="newImageBackgroundClicked" radius type="border" class="mr-5 mt-3" icon-pack="feather" icon="icon-arrow-down" @click.prevent="moveBackgroundCropper(0, 10)" />

              <vs-button v-show="newImageBackgroundClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-rotate-cw" @click.prevent="rotateBackgroundCropper(90)" />
              <vs-button v-show="newImageBackgroundClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-rotate-ccw" @click.prevent="rotateBackgroundCropper(-90)" />

              <vs-button v-show="newImageBackgroundClicked" class="mr-5 mt-3" color="success" icon-pack="feather" icon="icon-crop" @click.prevent="cropImageBackgroundCropper">Save</vs-button>
            </div>
          </div>
        </div>
      </div>

      <img :src="questionData.imageUrl" v-if="questionData.imageUrl" class="background-image-drag-and-drop"/>
    
      <div v-show="questionData.imageUrl">
        <vs-divider>Drag Combinations</vs-divider> 

        <vs-table ref="mappedLocationsTable" :data="questionData.mappedLocations">      
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="AddDraggable()" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>

          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody class="drag-and-drop-table-delete-button-right">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td class="drag-and-drop-table-image">
                  <img :src="tr.draggableImageUrl"/>
                </vs-td>

                <vs-td class="drag-and-drop-table-name">
                  <p class="product-name font-medium">{{ tr.name }}</p>
                </vs-td>

                <vs-td>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="canMappedLocationBeDeleted(tr.id, indextr)"></vs-button>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>
      <div v-show="!isCombinationTableActive">
        <vs-divider id="draggable-image-divider" class="mb-6 pt-0">Draggable Images</vs-divider>

          <vs-button 
            v-if="!isDraggableImageCropped" 
            class="mr-5 mb-4 mt-2 ml-8 new-signature-button-on-select" 
            color="success" 
            type="filled" 
            icon-pack="feather" 
            icon="icon-upload" 
            @click.prevent="showFileChooser">
            Upload Draggable Item
          </vs-button>

          <div class="vx-col cropper-div" ref="cropperdiv">
            <div v-show="newImageClicked">
              <input
                ref="inputDraggable"
                type="file"
                name="image"
                accept="image/*"
                @change="setImage"
              />

              <section class="cropper-area_tool">
                <div class="img-cropper">
                  <vue-cropper
                    v-show="!isDraggableImageCropped"
                    ref="cropper"
                    :src="questionData.draggableImage" 
                    preview=".preview"
                    :aspectRatio="1/1"
                    :initialAspectRatio="1/1"
                  />
                </div>
              </section>
            </div>

            <div v-show="newImageClicked && !isDraggableImageCropped" class="vx-vol cropper-area_buttons">
              <div class="vx-row ml-0">
                <vs-button v-show="newImageClicked" class="mr-5 mt-3" type="border" color="warning" icon-pack="feather" icon="icon-refresh-ccw" @click.prevent="reset">Reset</vs-button>

                <vs-button v-show="newImageClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-zoom-in" @click.prevent="zoom(0.2)" />
                <vs-button v-show="newImageClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-zoom-out" @click.prevent="zoom(-0.2)" />

                <vs-button v-show="newImageClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-left" @click.prevent="move(-10, 0)" />
                <vs-button v-show="newImageClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-right" @click.prevent="move(10, 0)" />
                <vs-button v-show="newImageClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-up" @click.prevent="move(0, -10)" />
                <vs-button v-show="newImageClicked" radius type="border" class="mr-5 mt-3" icon-pack="feather" icon="icon-arrow-down" @click.prevent="move(0, 10)" />

                <vs-button v-show="newImageClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-rotate-cw" @click.prevent="rotate(90)" />
                <vs-button v-show="newImageClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-rotate-ccw" @click.prevent="rotate(-90)" />

                <vs-button v-show="newImageClicked" class="mr-5 mt-3" color="success" icon-pack="feather" icon="icon-crop" @click.prevent="cropImage">Crop</vs-button>
              </div>
            </div>

            <div v-if="isDraggableImageCropped" class="img-cropper-drag-and-drop">
              <img :src="draggableImage" class="draggable-image-width ml-6"/>
              <vs-button class="mr-5 mt-2 ml-8" icon-pack="feather" color="success" type="filled" icon="icon-upload" @click.prevent="showFileChooser">Edit Draggable Item</vs-button>
            </div>
        </div>

        <vs-divider id="background-image-divider">Background Image</vs-divider>

        <div id="canvas" class="admin-background-canvas-background">
          <img :sceneUrl="questionData.imageUrl" class="canvas-area input-xxlarge"/>

        <vs-divider class="mb-6 pt-0">Complete Combination</vs-divider>
        
        <div class="vx-row">
          <vs-input placeholder="Enter a Name" class="w-1/3 md:w-2/3 lg:w-1/3 ml-4" v-model="locationMapDataName"/>
            <div class="display-left w-1/3 md:w-2/3 lg:w-1/3">
              <input class="w-8 h-8 cursor-pointer rounded-lg m-2" v-model="dragAndDropColor" type="color">
            </div>
        </div>

        <vs-spacer></vs-spacer>

        <div class="lg:pt-0 sm:pt-0 md:pt-4 pt-4">
          <vs-button color="success" class="ml-4 mb-2 vs-con-loading__container" ref="addMapLocationButton" :disabled="isDisabled" @click="saveMappedLocation">Add</vs-button>
        </div>

        <vs-divider class="mb-6 pt-0"></vs-divider>

        <div class="vx-row" v-show="!isCombinationTableActive">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="warning" type="border" class="mb-2" @click="isCombinationTableActive = true">Cancel</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row" v-show="isCombinationTableActive && questionData.mappedLocations.length != 0">
      <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container ml-12" @click="previewDragAndDrop">Preview</vs-button>
    </div>

    <div class="vx-row" v-show="isCombinationTableActive">
      <vs-spacer></vs-spacer>
      <div class="vx-col">
        <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" ref="saveQuestionButton" :disabled="saveButtonDisabled" @click="saveEditQuestion">Save</vs-button>
        <vs-button color="danger" v-show="questionData.id" class="mr-5 mb-2 vs-con-loading__container" @click="deleteQuestion" ref="deleteQuestionButton">Delete</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="isCardActiveLocal = false">Cancel</vs-button>
      </div>
    </div>

  </vx-card>
</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';
  import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss';
  import { AgGridVue } from 'ag-grid-vue';
  import vSelect from 'vue-select';

  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';

  import draggable from 'vuedraggable';
  import jQuery from './jquery';
  import canvas from './jquery.canvasAreaDrawDragAndDrop';

  export default {
    components: {
        AgGridVue,
        quillEditor,
        'v-select': vSelect,
        draggable,
        VueCropper
      },
    props: {     
      isCardActive: {
        type: Boolean,
        required: true
      },
      questionSelected: {
        type: Object,
        required: false
      },
      sourceQuizId: {
        type: Number,
        required: false
      },
      sourceQuizGradeType: {
        type: String,
        required: false
      },
      numberOfQuestions: {
        type: Number,
        required: false
      },
      questionCardTitle: {
        type: String,
        required: false
      },
      questionClassifications: {
        type: Array,
        required: false
      },
      questionCardCornerValue: {
        type: String,
        required: false
      },
    },
    data() {
      return {
        editorOption: {
          modules: {
            toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
          }
        },
        loadingColor:'#fff',
        isQuizListHidden: false,
        questionData: {
          id: 0,
          quizId: 0,
          questionClassificationId: 0,
          number: 0,
          title: "",
          questionText: "",
          score: "",
          imageUrl: null,
          draggableImage: "",
          mappedLocations: [],
          imageUrlWidth: 0
        },
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: true,
          suppressMovable: true,
        },
        classificationDropdown: 0,
        preview: false,
        cellViewPopupActive: false,
        cellView: "",
        selectedQuiz: [],
        quizzes: [],
        uploadedImage: [],
        newImageClicked: false,
        cropImg: null,
        showCropper: false,
        showCropImage: false,
        newImageBackgroundClicked: false,
        isDraggableImageCropped: false,
        locationMapData: {
          id: 0,
          navigationMapId: 0,
          name: "",
          imgWidth: 0,
          imgHeight: 0,
          points: []
        },
        mappedLocations: [],
        isDrawingComponentsShown: false,
        sceneImageUrl: "",
        sceneImageUrlTemp: "", 
        draggableImage: "",
        isPreviewAvailable: false,
        isPreviewActive: false,
        previewCanvasStyle: "",
        previewImgWidth: 0,
        previewImgHeight: 0,
        sceneImageUrlCropped: false,
        locationMapDataName: "",
        newImageBackgroundClicked: false,
        isCombinationTableActive: true,
        dragAndDropColor: '#E3E3E3',
        once:0,
        gradedQuiz:false,
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        },
      },
      isDisabled: function() {
        return !(this.locationMapDataName && this.draggableImage);
      },
      saveButtonDisabled: function() {
        var self = this;
        if(self.gradedQuiz){
          if(!self.questionData.score || self.questionData.score == 0){
            return true;
          }
        }
        return !(this.questionData.title && this.questionData.imageUrl && this.questionData.mappedLocations.length != 0);
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          this.once = 0;
          if(this.$refs){
            this.$vs.loading.close(this.$refs.saveQuestionButton.$el);
          }
          var self = this;
          self.gradedQuiz = self.sourceQuizGradeType == 'graded' ? true : false
          if(self.questionSelected.id){
            self.questionData.id = self.questionSelected.id;
            self.questionData.quizId = self.sourceQuizId;
            self.questionData.number = self.questionSelected.number;
            self.questionData.title = self.questionSelected.title;
            self.questionData.questionText = self.questionSelected.questionText;
            self.questionData.score = self.questionSelected.score == 0 ? "" : self.questionSelected.score;
            self.questionData.quizQuestionRows = self.questionSelected.quizQuestionRows;
            self.questionData.cornerValue = self.questionSelected.cornerValue;
            self.questionData.quizQuestionColumns = self.questionSelected.quizQuestionColumns;
            self.classificationDropdown = self.questionClassifications.filter(function (item) { return item.value == self.questionSelected.questionClassificationId; })[0];
            self.questionData.imageUrl = self.questionSelected.imageUrl;

            self.questionData.imageUrlWidth = self.questionSelected.imageUrlWidth;

            self.questionData.mappedLocations = [];

            self.getMappedLocations();

            if(self.questionData.imageUrl){
              self.uploadedImage = [];
              self.uploadedImage.push({
                url: self.questionData.imageUrl,        
              })
            }
          }else{
            self.initValues();
          }
        }
      }
    },
    methods: {
      saveData() {
        this.loadData();
      },
      saveEditQuestion() {
        this.once = this.once + 1;
        var self = this;
        self.showLoadingOnSaveQuestionButton();
        self.questionData.quizId = self.sourceQuizId;

        self.questionData.score = isNaN(parseInt(self.questionData.score)) ? 0 : parseInt(self.questionData.score);

        if(self.questionSelected.number != null)
          self.questionData.number = self.questionSelected.number;
        else
          self.questionData.number = self.numberOfQuestions + 1;

        self.questionData.questionClassificationId = isNaN(parseInt(self.classificationDropdown ? self.classificationDropdown.value : self.classificationDropdown)) ? null : parseInt(self.classificationDropdown.value);

        if(!self.questionData.imageUrlWidth){
          self.questionData.imageUrlWidth = self.questionData.mappedLocations[0].imgWidth;
        }

        if(self.once == 1){
          var onSuccess = response => {
          self.saveData();
          self.scrollToNavbar();
          self.isQuizListHidden = true;
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.saveQuestionButton.$el);
        };
        
        self.$ajaxPost(self, "question/addeditquestion", self.questionData, onSuccess, onFinally);
        }
        else{
          self.$vs.loading.close(self.$refs.saveQuestionButton.$el);
          self.isQuizListHidden = true;
        }
      },
      deleteQuestion() {
        var self = this;
        self.showLoadingOnDeleteButton();

        var onSuccess = response => {
          self.saveData();
          self.scrollToNavbar();
          self.isQuizListHidden = true;
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteQuestionButton.$el);
        };

        self.$ajaxDelete(self, "Question/DeleteQuestion/" + self.questionData.id, onSuccess, onFinally);
      },
      initValues() {
        this.questionData.id = 0;
        this.questionData.number = 0;
        this.questionData.title = "";
        this.questionData.questionText = "";
        this.questionData.score = "";
        this.questionData.quizQuestionRows = [];
        this.questionData.quizQuestionColumns = [];
        this.questionData.number = 0;
        this.questionData.cornerValue = "";
        this.questionData.imageUrl = null;
        this.questionData.imageUrlWidth = null;
        this.questionData.questionClassificationId = 0;
        this.questionData.draggableImage = "";
        this.questionData.mappedLocations = [];
        this.classificationDropdown = 0;
        this.dragAndDropColor = '#E3E3E3'
        this.errors.clear();
        this.preview = false;
        this.previewColumns = [];
        this.selectedQuiz = [];
        this.quizzes = [];
        this.uploadedImage = [];
        this.isDrawingComponentsShown = false;
        this.sceneImageUrl = "";
        this.gradedQuiz = false;
      },
      addNewClassification(newClassification) {
        const self = this;
        self.$ajaxGet(self, "Question/AddClassification?name=" + newClassification.label, function(response){
          self.classificationDropdown = {value: response.data.value, label: response.data.text};
        });
      },
      showLoadingOnSaveQuestionButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveQuestionButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.deleteQuestionButton.$el,
          scale: 0.45
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      scrollToDivider() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("dividerGlobal"), 100, scrollOptions);
      },
      cellClicked(val1){
        var colIn = val1.column.colId;
        var rowIn = val1.rowIndex;

        if(colIn == this.questionData.cornerValue){
          this.cellViewPopupActive = true;
          this.cellView = val1.data.text;
        }
      },
      loadData() {
        const self = this;

        var onSuccess = function (response) {
          self.quizzes = response.data;

          self.quizzes.forEach(element => {

            if(self.sourceQuizId == element.id){
              self.selectedQuiz = element;
            };            
          });

          self.$emit('saveData');
          self.$emit('handleSelectedQuiz', self.selectedQuiz);
          self.initValues();
        };
        var onFinally = function () {
          
        };

        self.$ajaxGet(self, "quiz/ListQuizzes", onSuccess, onFinally);
      },
      fileRemovedQuestion(error, file) {
        this.questionData.imageUrl = null;
      },
      clearImageUrl() {
        this.uploadedImage = [];
        this.questionData.imageUrl = null;
      },
      cropImage() {
        var self = this;

        self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();

        self.showLoadingOnElement("cropperdiv", 0.45, "material");

        var fileExt = self.cropImg.substring(
          self.cropImg.indexOf("/") + 1, 
          self.cropImg.indexOf(";")
        );

        var byteString = atob(self.cropImg.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([ab], { type: 'image/' + fileExt });
        
        var data = new FormData();
        data.append('image', blob, "signature_" + self.questionData.id + "." + fileExt);

        var onSuccess = response => {
          self.draggableImage = response.data.url;
          self.showCropImage = true;
          self.isDraggableImageCropped = true;

          setTimeout(() => {
            self.scrollToBackgroundImage();
          }, 200);
        };

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.cropperdiv.$el);
        };

        self.$ajaxPost(self, "tempupload", data, onSuccess, onFinally);
      },
      move(offsetX, offsetY) {
        this.$refs.cropper.move(offsetX, offsetY);
      },
      reset() {
        this.cropImg = null;
        this.$refs.cropper.reset();
      },
      rotate(deg) {
        this.$refs.cropper.rotate(deg);
      },
      setImage(e) {
        const file = e.target.files[0];
        if (file.type.indexOf('image/') === -1) {
          alert('Please select an image file');
          return;
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.questionData.draggableImage = event.target.result;
            this.$refs.cropper.replace(event.target.result);
            this.isDraggableImageCropped = false;

            this.$refs.inputDraggable.value = "";
          };
          reader.readAsDataURL(file);
          this.newImageClicked = true;
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },
      previewDragAndDrop() {
        var self = this;

        if(!self.questionData.imageUrlWidth){
          self.questionData.imageUrlWidth = self.questionData.mappedLocations[0].imgWidth;
        }

        localStorage.setItem("questionData", JSON.stringify(this.questionData));

        window.open('../quizdraganddropreview', "_blank");
      },
      showFileChooser() {
        this.showCropImage = false;
        this.$refs.inputDraggable.click();
      },
      zoom(percent) {
        this.$refs.cropper.relativeZoom(percent);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      initCanvas() {
        $('.canvas-area[sceneUrl]').canvasAreaDraw();
      },
      dataSaved() {
        this.navMapSidebar = false;
        this.loadData();
      },
      mapLocations(id) {
        this.navMapSidebar = false;
        this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
        this.navigationMapId = id;
        this.loadMappedLocations(id);
        setTimeout(function(){
          $('.canvas-area[sceneUrl]').canvasAreaDraw();
        }, 500);
        this.isDrawingComponentsShown = true;
      },
      // rowImageClicked(tr) {
      //   this.navMapSidebar = false;
      //   this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
      //   this.navigationMapId = tr.id;
      //   this.sceneImageUrl = tr.sceneImageUrl;
      //   this.loadMappedLocations(this.navigationMapId);
      //   setTimeout(function(){
      //     $('.canvas-area[sceneUrl]').canvasAreaDraw();
      //   }, 500);
      //   this.isDrawingComponentsShown = true;
      // },
      done(){
        this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
        this.loadData();
        $('canvas').remove();
      },
      saveMappedLocation() {
        var self = this;
        if($('.canvas-area')[0].value){
          self.locationMapData = {};
          self.locationMapData.points = ($('.canvas-area')[0].value).split(",").map(Number);

          self.locationMapData.imgHeight = $('canvas')[0].height;
          self.locationMapData.imgWidth = $('canvas')[0].width;

          self.locationMapData.draggableImageUrl = self.draggableImage;
          self.locationMapData.name = self.locationMapDataName;
          self.locationMapData.xCoordinate = self.locationMapData.points[0];
          self.locationMapData.yCoordinate = self.locationMapData.points[1];
          self.locationMapData.color = self.dragAndDropColor;

          self.questionData.mappedLocations.push(self.locationMapData);

          self.$refs.inputDraggable.value = "";

          self.isPreviewAvailable = true;
          self.locationMapDataName = "";
          self.showCropImage = true;
          self.draggableImage = "";
          self.isCombinationTableActive = true;
        }
      },
      showLoadingOnMappedLocationsTable() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.mappedLocationsTable.$el,
          scale: 1
        });
      },
      resetCanvas() {
        $("#resetCanvas").click();
      },
      cropImageBackgroundCropper() {
        var self = this;

        self.cropImg = self.$refs.backgroundCropper.getCroppedCanvas().toDataURL();

        self.showLoadingOnElement("backgroundCropperdiv", 0.45, "material");

        var fileExt = self.cropImg.substring(
          self.cropImg.indexOf("/") + 1, 
          self.cropImg.indexOf(";")
        );

        var byteString = atob(self.cropImg.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([ab], { type: 'image/' + fileExt });
        
        var data = new FormData();
        data.append('image', blob, "signature_" + self.questionData.id + "." + fileExt);

        var onSuccess = response => {
          self.locationMapData.points = [];
          self.questionData.imageUrl = response.data.url;
          self.newImageBackgroundClicked = false;

          if(document.getElementsByTagName('canvas'))
            $('canvas').remove();
        };

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.backgroundCropperdiv.$el);
        };

        self.$ajaxPost(self, "tempupload", data, onSuccess, onFinally);
      },
      setCanvas(){
        var self = this;

        try{
          $('canvas').remove();
        }catch(e){

        }

        self.initCanvas();
        $("#addPointCanvas").click();

        setTimeout(() => {
          self.previewImgHeight = $('canvas')[0].height;
          self.previewImgWidth = $('canvas')[0].width;
        }, 69);
      },
      moveBackgroundCropper(offsetX, offsetY) {
        this.$refs.backgroundCropper.move(offsetX, offsetY);
      },
      resetBackgroundCropper() {
        this.cropImg = null;
        this.$refs.backgroundCropper.reset();
      },
      rotateBackgroundCropper(deg) {
        this.$refs.backgroundCropper.rotate(deg);
      },
      setImageBackgroundCropper(e) {
        const file = e.target.files[0];
        if (file.type.indexOf('image/') === -1) {
          alert('Please select an image file');
          return;
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.sceneImageUrlTemp = event.target.result;
            this.$refs.backgroundCropper.replace(event.target.result);
          };
          reader.readAsDataURL(file);
          this.newImageBackgroundClicked = true;
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },
      zoomBackgroundCropper(percent) {
        this.$refs.backgroundCropper.relativeZoom(percent);
      },
      showFileChooserBackgroundCropper() {
        if(this.questionData.mappedLocations.length == 0){
          this.$refs.inputBackgroundCropper.click();
        }else{
          this.$vs.notify({
            title:'Information',
            color: "warning",
            text: "You have saved locations on this background, remove the locations first before uploading",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-mail'
          });
        }
      },
      AddDraggable(){
        var self = this;

        self.isCombinationTableActive = false;
        self.setCanvas();

        self.scrollToDraggableImages();
      },
      scrollToDraggableImages(){
        var scrollOptions = {
          easing: "ease-in",
          offset: 500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };
        this.$scrollTo(
          document.getElementById("draggable-image-divider"),
          500,
          scrollOptions
        );
      },
      scrollToBackgroundImage(){
        var scrollOptions = {
          easing: "ease-in",
          offset: -125,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };
        this.$scrollTo(
          document.getElementById("background-image-divider"),
          500,
          scrollOptions
        );
      },
      getMappedLocations(){
        var self = this;
        
        var onSuccess = response => {
          self.questionData.mappedLocations = response.data;
        };

        self.$ajaxGet(self, "Question/GetMappedLocationsForQuestion?questionId=" + self.questionData.id, onSuccess);
      },
      canMappedLocationBeDeleted(id, indextr){
        var self = this;

        if(id){
          var onSuccess = response => {
            if(!response.data){
              self.questionData.mappedLocations.splice(indextr, 1);
            } else {
              self.$vs.notify({
                title: "Attention",
                color: "warning",
                text: "Drag Combination can not be deleted because students have already answered the question with the combination",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-info"
              });
            }
          };
  
          self.$ajaxGet(self, "Question/CanMappedLocationBeDeleted?locationId=" + id, onSuccess);
        } else {
          self.questionData.mappedLocations.splice(indextr, 1);
        }
        
      }
    },
    mounted(){

    }
  }

</script>

<style lang="scss">

#cellTextArea, #cellViewArea {
  height: 200px;
}

.numberinput{
  background: #ffffff;
  float: left;
}

#cellTextPopup, #cellViewPopup {
  .vs-component.vs-con-textarea.vs-textarea-primary:not(.focusx){
    border-color: #828282 !important;
  }

  .focusx.vs-textarea-primary {
    border: 1px solid rgba(var(--vs-primary),1)!important;
  }

  z-index: 99999;
}

#text_input {
  width: 50%;
}

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }

  .image-in-drag-list {
    width: 20%;
  }
}

.cropper-div {
  input[type="file"] {
    display: none;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 0;
  }
  .header h2 {
    margin: 0;
  }
  .header a {
    text-decoration: none;
    color: black;
  }
  .cropper-area_tool {
    width: 60%;
  }
  .cropper-area_buttons {
    width: 100%;
  }
  .actions {
    margin-top: 1rem;
    display: flex;
  }
 
  textarea {
    width: 100%;
    height: 100px;
  }
  .preview-area {
    width: 307px;
  }
  .preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
  }
  .preview-area p:last-of-type {
    margin-top: 1rem;
  }
  .preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
  }
  .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  }
  .cropped-image img {
    max-width: 100%;
  }
}

.img-cropper-drag-and-drop{
  width: 100%;
  img{
    width: 100%;
  }
}

.draggable-image-width{
  width: 20% !important;
}

.circular {
  width: 500px;
  height: 500px;
  background-size: cover;
}

#map {
  display: none;
}

#map .state {
  cursor: pointer;
}

#map .state .shape {
  cursor: pointer;
  -width: 0;
}

#map .state .label_icon_state {
  fill: #fff;
  font-family: Arial;
  font-size: 11px;
  line-height: 12px;
  font-weight: normal;
}

#map .state .label_state {
  display: none;
  font-family: Arial;
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
}

#map .state:hover .label_state, #map .state.hover .label_state {
  display: block;
}

#map .map-location .state .shape {
  fill: #ffffff;
  opacity: 0.4;
}

#map .map-location .state:hover .shape, #map .map-location .state.hover .shape .area {
  fill: #ffffff;
  opacity: 0.6;
}

#map .map-location .state:hover .icon_state, #map .map-location .state.hover .icon_state {
  fill: #5a95ce;
}

#map .map-location {
  animation: blinker 1.2s linear infinite;
  -webkit-animation: blinker 1.2s linear infinite;
}

.student-canvas-background{
  img, canvas{
    background-size: contain !important;
    background-repeat: no-repeat !important;
  }
  
}

.upload-background-image{
  display: flex;
  justify-content: center;
}

.background-image-drag-and-drop{
  width: 400px;
  height: 400px;
  display: flex !important;
  justify-content: center !important;
}

.drag-and-drop-table-delete-button-right{
  span{
    display: flex;
    justify-content: flex-end;
  }
}

.drag-and-drop-table-name{
  display: flex;
  justify-content: center;
}

.drag-and-drop-table-image{
  width: 60px;

  img{
    width: 50px;
    height: 50px;
  }
}

</style>
